import * as swcHelpers from '@swc/helpers';
import { getProductType } from './get-shopping-list-product-type.js';

const mapShoppingListToWishlistItems = (shoppingList)=>{
    if (shoppingList) {
        return shoppingList.items.map((item)=>{
            let additionalFields = {};
            switch(item.variant.__typename){
                case 'AccessoriesVariant':
                case 'ContactLensVariant':
                case 'FrameVariant':
                case 'LensTypeVariant':
                case 'PrescriptionGlassesPackageOptionsVariant':
                case 'PrescriptionGlassesPackageVariant':
                case 'ReadyReaderVariant':
                case 'SolutionVariant':
                case 'SunglassesVariant':
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                    additionalFields = {
                        // According to schema media.images is not nullable, but it sometimes is in the response.
                        // OpCos likely have not added an image for each product. Added ? as a workaround.
                        imageSrc: (ref = item.variant.media.images[0]) === null || ref === void 0 ? void 0 : ref.url,
                        originalPrice: (ref1 = item.variant.prices.originalPrice) === null || ref1 === void 0 ? void 0 : ref1.amount,
                        discountedPrice: (ref2 = item.variant.prices.discountedPrice) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.amount,
                        discountValue: (ref4 = item.variant.prices.discountedPrice) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discountInformation) === null || ref5 === void 0 ? void 0 : ref5.value,
                        currencyCode: (ref6 = item.variant.prices.originalPrice) === null || ref6 === void 0 ? void 0 : ref6.currencyCode
                    };
                    break;
                default:
                    additionalFields = {};
                    break;
            }
            const shoppinglistItem = swcHelpers.objectSpread({
                sku: item.sku,
                name: item.name,
                productType: getProductType(item.variant.__typename),
                slug: item.product.slug
            }, additionalFields);
            return shoppinglistItem;
        });
    }
    return [];
};

export { mapShoppingListToWishlistItems };
//# sourceMappingURL=shopping-list-to-wishlist-mapper.js.map
